import { Box } from "@mui/material"
import { CenteredBox } from "./boxes"
import LogoImage from './../../../assets/images/logo.png'
const Logo = ({...rest}) => {
    return <CenteredBox  {...rest}>
        <img src={LogoImage} style={{ width: "100%",maxWidth: "130px",objectFit:"contain" }} alt="" />
    </CenteredBox>
}
export default Logo